import React from "react";
import { useDataContext } from "../contexts/Context";

export default function Button({ text, codeLink, siteLink }) {
  const { loading } = useDataContext();
  return (
    <div>
      <div style={{ position: "relative", width: "24vh", height: "8.6vh" }}>
        <a
          className="btn2"
          style={{
            position: "absolute",
            zIndex: 5,
            color: loading && "gray",
            cursor: loading && "default",
          }}
          href={codeLink ? codeLink : siteLink}
          target="_blank"
        >
          {text}
        </a>
        <div
          className="btn2--glow"
          style={{ display: loading && "none" }}
        ></div>
      </div>
    </div>
  );
}
